// extracted by mini-css-extract-plugin
export default {"TermsConditions":"terms-conditions_TermsConditions__+ataS","Confirmation":"terms-conditions_Confirmation__8tj9P"};